import { Heading, TextBlock, Button } from 'neon-design-system';
import { Grid } from '@material-ui/core';
import { SupportContactCard } from '../../../../components/SupportContactCard/SupportContactCard';
import { ProcessStepper } from '../../../../components/ProcessStepper/ProcessStepper';
import { config } from '../../../../config';

const steps = ['Select trades from ‘Positions’ in Portfolio', 'Fill in all the details and submit the request', 'Come back here to monitor your requests'];

export const NoAccountChangeRequestView = () => {
  return (
    <Grid container spacing={4} item xs={12}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Heading styleName="largeTitle">Account Change requests</Heading>
          </Grid>
          <Grid item xs={12}>
            <TextBlock styleName="largeBody2" shade={400}>
              Move trades between accounts from Portfolio, and monitor the status of your requests from here.
            </TextBlock>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Heading styleName="title1">Process overview</Heading>
              </Grid>
              <Grid item xs={12}>
                <TextBlock styleName="body">Moving trades between accounts is easy, simply follow the steps below.</TextBlock>
              </Grid>
              <Grid item xs={12}>
                <ProcessStepper steps={steps} />
              </Grid>
              <Grid item xs={12}>
                <TextBlock styleName="body">If we require more information in order to fulfill your request, we’ll get in touch.</TextBlock>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4}>
            <SupportContactCard />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={8}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Heading styleName="title1">Make your first Account Change request</Heading>
          </Grid>
          <Grid item xs={12}>
            <TextBlock styleName="body">
              You currently have no requests made on your accounts. Using the button below you can make your first request. You can monitor all your requests
              from this section.
            </TextBlock>
          </Grid>
          <Grid item xs={12}>
            <Button colorType="primary" onClick={() => (window.location.href = config.portfolioTradesPage)} size="large">
              Navigate to Portfolio
            </Button>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextBlock styleName="caption1">
              By clicking the above button you’ll navigate to the Positions screen in Neon Portfolio, where you can select and move trades.
            </TextBlock>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
